import { useSrpContext } from '@/src/contexts'
import { useMessages, useTranslations } from 'next-intl'

import FareIntelligence from './fareIntelligence'

const EN_MONTHS = ['january','february','march','april','may','june','july','august','september','october','november','december']

function buildMonthMap (messages: Record<string, unknown>): Record<string, string> {
    const months = (messages.form as Record<string, unknown>)?.months as Record<string, string> | undefined
    if (!months) return {}
    const map: Record<string, string> = {}
    for (const key of EN_MONTHS) {
        if (months[key]) map[key] = months[key]
    }
    return map
}

function translateMonth (month: string, monthMap: Record<string, string>): string {
    return monthMap[month.toLowerCase()] ?? month
}

const FareIntelligenceWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')
    const messages = useMessages()
    const monthMap = buildMonthMap(messages as Record<string, unknown>)

    const whenToBook = sections?.whenToBook
    if (!whenToBook?.fareOverview) return null

    const currency = whenToBook.fareSummary?.currency ?? 'SAR'
    const rawFares = whenToBook.monthlyBreakdown ?? []
    const maxFare = Math.max(...rawFares.map(f => Number(f.avgFare) || 0), 1)

    const monthlyFares = rawFares.map(f => {
        const fare = Number(f.avgFare) || 0
        const translated = translateMonth(f.month, monthMap)
        return {
            shortLabel: translated.slice(0, 3),
            value: fare,
            heightPercent: (fare / maxFare) * 100,
        }
    })

    return (
        <FareIntelligence
            fareOverview={whenToBook.fareOverview}
            bookingAdvice={whenToBook.bookingAdvice}
            weekendVsWeekday={whenToBook.weekendVsWeekday}
            monthlyFares={monthlyFares}
            monthlyChartTitle={t('monthlyAverageFare')}
            monthlyUnit={t('perMonth', { currency })}
        />
    )
}

export default FareIntelligenceWrapper
